import React from 'react';
import { Link } from 'react-router-dom';
import { trackEvent } from '../utils/analytics';

function Landing() {
  return (
    <div style={{ background: '#fff', minHeight: '100vh' }}>
      {/* Nav */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 24px', borderBottom: '1px solid #f3f4f6' }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '8px', textDecoration: 'none' }}>
          <img src="/belong.png" alt="Belong" style={{ height: '28px' }} />
          <span style={{ fontWeight: 700, fontSize: '18px', color: '#7C3AED' }}>Belong</span>
        </Link>
        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
          <Link to="/b" style={{ color: '#4B5563', textDecoration: 'none', fontSize: '14px', fontWeight: 500 }}>Browse</Link>
          <Link to="/login" style={{ color: '#7C3AED', textDecoration: 'none', fontSize: '14px', fontWeight: 500 }}>Sign In</Link>
          <Link to="/register" style={{ background: '#7C3AED', color: '#fff', padding: '8px 16px', borderRadius: '8px', textDecoration: 'none', fontSize: '14px', fontWeight: 600 }}>Join Free</Link>
        </div>
      </div>

      {/* Hero */}
      <div style={{ maxWidth: '700px', margin: '0 auto', padding: '60px 24px 40px', textAlign: 'center' }}>
        <h1 style={{ fontSize: '2.2rem', lineHeight: '1.3', fontWeight: 700, color: '#1f2937', marginBottom: '16px' }}>
          A safe place to be honest about who you are
        </h1>
        <p style={{ fontSize: '1.1rem', color: '#4b5563', lineHeight: '1.7', marginBottom: '24px' }}>
          Belong is for people with invisible identities — ADHD, chronic illness, cultural background, neurodiversity, mental health conditions — who want to connect with others who truly understand. No judgment. No exposure. Just real people who get it.
        </p>
        <img 
          src="/images/undraw_getting-coffee_rzv2.svg" 
          alt="" 
          style={{ maxWidth: '280px', width: '100%', margin: '0 auto 28px', display: 'block' }}
          onError={(e) => e.target.style.display = 'none'}
        />
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/b" onClick={() => trackEvent('cta_click', { button: 'browse', page: 'welcome' })} style={{ background: '#10b981', color: '#fff', padding: '14px 28px', borderRadius: '10px', textDecoration: 'none', fontWeight: 600, fontSize: '16px' }}>
            Browse Discussions →
          </Link>
          <Link to="/register" onClick={() => trackEvent('cta_click', { button: 'join', page: 'welcome' })} style={{ background: '#7C3AED', color: '#fff', padding: '14px 28px', borderRadius: '10px', textDecoration: 'none', fontWeight: 600, fontSize: '16px' }}>
            Join Belong
          </Link>
        </div>
      </div>

      {/* Why Belong exists */}
      <div style={{ background: '#faf8ff', padding: '48px 24px', borderTop: '1px solid #ede9fe' }}>
        <div style={{ maxWidth: '700px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#1f2937', marginBottom: '16px' }}>Why Belong exists</h2>
          <p style={{ fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '16px' }}>
            Some experiences are hard to talk about openly — not because you're ashamed, but because not everyone understands. Living with ADHD, navigating caste identity in a new country, managing chronic pain that no one can see, or carrying the weight of anxiety that others dismiss.
          </p>
          <p style={{ fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '16px' }}>
            Belong was created because the founder experienced this firsthand — connecting with a few people at a local YMCA and observing that people need a safe way to find others who share their invisible experiences. Not a support group with a therapist. Not a public forum where your employer might see. Just a private, human connection with someone who genuinely gets it.
          </p>
          <p style={{ fontSize: '1rem', color: '#4b5563', lineHeight: '1.8' }}>
            We built Belong so that moment of "wait, you too?" can happen for anyone, anywhere.
          </p>
        </div>
      </div>

      {/* How we keep you safe */}
      <div style={{ padding: '48px 24px' }}>
        <div style={{ maxWidth: '700px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#1f2937', marginBottom: '24px' }}>How we keep this space safe</h2>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div style={{ padding: '20px', background: '#f0fdf4', borderRadius: '12px', border: '1px solid #bbf7d0' }}>
              <h3 style={{ fontSize: '1rem', fontWeight: 600, color: '#166534', marginBottom: '8px' }}>🔒 Anonymous by default</h3>
              <p style={{ fontSize: '14px', color: '#4b5563', lineHeight: '1.6', margin: 0 }}>
                Your identity is never shown until you choose to share it. No real name required to join. You control exactly what each person can see about you, one level at a time — and both sides must agree before anything is revealed.
              </p>
            </div>

            <div style={{ padding: '20px', background: '#eff6ff', borderRadius: '12px', border: '1px solid #bfdbfe' }}>
              <h3 style={{ fontSize: '1rem', fontWeight: 600, color: '#1e40af', marginBottom: '8px' }}>🛡️ Moderated content</h3>
              <p style={{ fontSize: '14px', color: '#4b5563', lineHeight: '1.6', margin: 0 }}>
                Every AI-generated post is reviewed by a human moderator before it appears. User-generated content is monitored for harmful material. We use both AI-based detection and community moderators to keep discussions supportive and genuine.
              </p>
            </div>

            <div style={{ padding: '20px', background: '#fef3c7', borderRadius: '12px', border: '1px solid #fde68a' }}>
              <h3 style={{ fontSize: '1rem', fontWeight: 600, color: '#92400e', marginBottom: '8px' }}>🚫 Bad actor protections</h3>
              <p style={{ fontSize: '14px', color: '#4b5563', lineHeight: '1.6', margin: 0 }}>
                Users can block and report anyone instantly. Reported accounts are reviewed within 24 hours. We rate-limit connection requests to prevent spam, and our trust scoring system restricts new accounts from messaging until they've established credibility.
              </p>
            </div>

            <div style={{ padding: '20px', background: '#faf5ff', borderRadius: '12px', border: '1px solid #e9d5ff' }}>
              <h3 style={{ fontSize: '1rem', fontWeight: 600, color: '#6b21a8', marginBottom: '8px' }}>🔐 Encrypted data</h3>
              <p style={{ fontSize: '14px', color: '#4b5563', lineHeight: '1.6', margin: 0 }}>
                All personal information (names, locations, emails) is encrypted before it's stored. We don't sell data. We don't show ads. We don't track you across the internet. Your information exists only to help you connect — nothing else.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* How it works */}
      <div style={{ background: '#f9fafb', padding: '48px 24px', borderTop: '1px solid #e5e7eb' }}>
        <div style={{ maxWidth: '700px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#1f2937', marginBottom: '24px', textAlign: 'center' }}>How Belong works</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px' }}>
            <div style={{ background: '#fff', padding: '24px', borderRadius: '12px', border: '1px solid #e5e7eb' }}>
              <div style={{ fontSize: '2rem', marginBottom: '12px' }}>1️⃣</div>
              <h3 style={{ fontSize: '1rem', fontWeight: 600, marginBottom: '8px' }}>Browse anonymously</h3>
              <p style={{ fontSize: '14px', color: '#6b7280', lineHeight: '1.6', margin: 0 }}>Read discussions in identity spaces — ADHD, chronic illness, caste, anxiety, and more. No account needed to read. Everything is anonymous.</p>
            </div>
            <div style={{ background: '#fff', padding: '24px', borderRadius: '12px', border: '1px solid #e5e7eb' }}>
              <div style={{ fontSize: '2rem', marginBottom: '12px' }}>2️⃣</div>
              <h3 style={{ fontSize: '1rem', fontWeight: 600, marginBottom: '8px' }}>Find someone who gets it</h3>
              <p style={{ fontSize: '14px', color: '#6b7280', lineHeight: '1.6', margin: 0 }}>See posts that resonate? Connect with the person behind them. Send a connection request — they'll see you share an identity before anything else.</p>
            </div>
            <div style={{ background: '#fff', padding: '24px', borderRadius: '12px', border: '1px solid #e5e7eb' }}>
              <div style={{ fontSize: '2rem', marginBottom: '12px' }}>3️⃣</div>
              <h3 style={{ fontSize: '1rem', fontWeight: 600, marginBottom: '8px' }}>Reveal at your pace</h3>
              <p style={{ fontSize: '14px', color: '#6b7280', lineHeight: '1.6', margin: 0 }}>Start anonymous. Share names when you're ready. Then location, profession, contact info — each step requires both people to agree. You're always in control.</p>
            </div>
            <div style={{ background: '#fff', padding: '24px', borderRadius: '12px', border: '1px solid #e5e7eb' }}>
              <div style={{ fontSize: '2rem', marginBottom: '12px' }}>4️⃣</div>
              <h3 style={{ fontSize: '1rem', fontWeight: 600, marginBottom: '8px' }}>Build real relationships</h3>
              <p style={{ fontSize: '14px', color: '#6b7280', lineHeight: '1.6', margin: 0 }}>Message each other, form groups, attend events. What starts as anonymous support becomes a genuine friendship with someone who truly understands your experience.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Who built this */}
      <div style={{ padding: '48px 24px' }}>
        <div style={{ maxWidth: '700px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#1f2937', marginBottom: '16px' }}>Who built this</h2>
          <p style={{ fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '16px' }}>
            Belong was built by technology leaders with over 20 years of experience designing platforms at Amazon and PayPal — systems trusted by hundreds of millions of people. We bring that same level of security and reliability to protecting what matters most: your identity and your story.
          </p>
          <p style={{ fontSize: '1rem', color: '#4b5563', lineHeight: '1.8' }}>
            We're based in Austin, TX. We don't take venture capital. We don't have advertisers to please. Our only goal is to help people find genuine connection around the things that matter most to them.
          </p>
        </div>
      </div>

      {/* CTA */}
      <div style={{ background: '#7C3AED', padding: '48px 24px', textAlign: 'center' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#fff', marginBottom: '12px' }}>Ready to find your people?</h2>
        <p style={{ fontSize: '1rem', color: '#e9d5ff', marginBottom: '24px' }}>Free forever. Anonymous by default. Your pace, your rules.</p>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/register" onClick={() => trackEvent('cta_click', { button: 'join_bottom', page: 'welcome' })} style={{ background: '#fff', color: '#7C3AED', padding: '14px 28px', borderRadius: '10px', textDecoration: 'none', fontWeight: 600, fontSize: '16px' }}>
            Join Belong →
          </Link>
          <Link to="/b" style={{ background: 'transparent', color: '#fff', padding: '14px 28px', borderRadius: '10px', textDecoration: 'none', fontWeight: 600, fontSize: '16px', border: '2px solid rgba(255,255,255,0.5)' }}>
            Browse Discussions
          </Link>
        </div>
      </div>

      {/* Footer */}
      <div style={{ padding: '24px', textAlign: 'center', borderTop: '1px solid #e5e7eb' }}>
        <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '12px' }}>
          <Link to="/faq" style={{ color: '#6b7280', fontSize: '14px', textDecoration: 'none' }}>FAQ</Link>
          <Link to="/privacy" style={{ color: '#6b7280', fontSize: '14px', textDecoration: 'none' }}>Privacy Policy</Link>
          <Link to="/terms" style={{ color: '#6b7280', fontSize: '14px', textDecoration: 'none' }}>Terms</Link>
          <Link to="/help" style={{ color: '#6b7280', fontSize: '14px', textDecoration: 'none' }}>Contact</Link>
          <a href="mailto:belong@ourbelong.com" style={{ color: '#6b7280', fontSize: '14px', textDecoration: 'none' }}>belong@ourbelong.com</a>
        </div>
        <p style={{ fontSize: '12px', color: '#9ca3af' }}>© 2026 Belong. All rights reserved. Austin, TX.</p>
      </div>
    </div>
  );
}

export default Landing;
